var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"about-wrp content-box fadeInUp"},[(_vm.name)?_c('contact-thanks',{attrs:{"name":_vm.name}}):_c('contact-form',{ref:"contactForm",on:{"formSubmitted":function (e){ return _vm.name = e.split(' ')[0]; }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }